var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M25.2949 5.10156L4.94601 24.9607","stroke":"#4035C3","strokeWidth":"1.5","key":0}),React.createElement("path",{"d":"M13.7695 24.8691L4.85339 24.8691L4.85339 16.1676","stroke":"#4035C3","strokeWidth":"1.5","key":1}),React.createElement("path",{"d":"M16.5332 4.76953H25.4493V13.4711","stroke":"#4035C3","strokeWidth":"1.5","key":2})]);
}

Expand.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = Expand;

Expand.default = Expand;
